import { BlueCorornavirus, Mouse1, Mouse2,Laptop1, Laptop2, Laptop3 } from "../../assets/Home";
export const processData =[
{
  id:"process-001",
  serviceId: 9,
  pickupStatus: "Received",
  receivedDate: "2025-09-04",
  partsRequired: true,
  partOrder: {
    parts: [{ name: "jksjkaskjas", qty: 2, price: 100 }],
    timeline: "Part Ordered – Sep 4, 3:58 PM. Expected by Sep 6",
  },
  partReceived: {
    parts: [
      { name: "jksjkaskjas", qty: 2, price: 100 }
    ],
    timeline: "Part Received – Repair scheduled on Sep 4, 3:58 PM",
    receiveDate: "Sep 4, 3:58 PM",
  },
  repairInProgress: {
    progress: [
      {
        name: "Disassembly",
        completed: true,
        timestamp: "9/4/2025, 3:58:28 PM",
      },
      {
        name: "Faulty Component Removed",
        completed: true,
        timestamp: "9/4/2025, 3:58:30 PM",
      },
      {
        name: "New Component Installed",
        completed: true,
        timestamp: "9/4/2025, 3:58:31 PM",
      },
      {
        name: "Reassembly",
        completed: false,
        timestamp: "9/4/2025, 3:58:33 PM",
      },
    ],
    notes: "ksksjkasksajkassjkjasjk",
    photos: [Laptop1, Laptop2, Laptop3,Laptop1],
    //status: "Completed",
  },
  testingPhase: {
    results: [
      { name: "Power & Battery Check", status: "In Progress" },
      { name: "Display & Screen Test", status: "Passed" },
      { name: "Storage & RAM Performance", status: "Failed" },
      { name: "Cooling & Fan Operation", status: "Failed" },
      { name: "Connectivity (WiFi / Ports)", status: "Passed" },
      { name: "Software / OS Boot & Stability", status: "In Progress" },
    ],
    timeline: [
      "Testing Completed – 9/4/2025, 3:59:10 PM",
      "Some tests need review",
    ],
    allTestsPassed: false,
  },
  qualityControl: {
    status: "Completed",
    date: "9/4/2025, 3:59:52 PM",
    message: "Your device has passed quality control checks.",
    checkedItems: [
      {
        name:"Device boots properly",
        completed: true,
      },
      {
        name:"No overheating during operation",
        completed: true,
      },
      {
        name:"All ports & components working",
        completed: true,
      },
      {
        name:"Original problem resolved",
        completed: true,
      }
  ],
  },
  invoice: {
    additionalCharges: [
      { 
        name: "jsjksdjksdjksdjksd", 
        amount: 200 
      },
      { 
        name: "Delivery charges", 
        amount: 200 
      },
    ],
    
    date: "2025-09-04",
  },
  paymentByCustomer:{
    status:"",
    paymentMode:"",
    date:"2025-09-03",
    referenceTransactionId: "",
  },
  payment: {
    status: "Completed",
    paymentMode: "Cash",
    confirmDate: "2025-09-04",
    referenceTransactionId: "",
  },
  delivery: {
    courier: "",
    trackingId: "asdf",
    pickupDate: "2025-09-04",
    estimateDate: "2025-09-05",
    shipmentType: "Standard",
    paymentMode: "COD",
    deliveryPersonNumber: "9403097296",
    deliveryPerson: "abc xyz",
    pickupLocation: "kskkdsksdksksdksksd",
    deliveryAddress:
      "Flat 12A, Block C, 2nd Green Heights, Indiranagar Landmark: Near Metro Station Bangalore, Karnataka - 560038",
     photos: [Laptop1, BlueCorornavirus, Mouse2,Mouse1],
  },
},
] ;
